import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-job-position',
  templateUrl: './job-position.component.html',
  styleUrls: ['./job-position.component.scss'],
})
export class JobPositionComponent {
  jobPositionList = [
    {
      positionName: 'Android Developer',
      className: 'box__image-detail--android',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Android_Developer.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Android_Developer.webp',
      imageType: 'jpg',
      imageAlt: 'Android Developer',
      link: 'https://flowaccount.breezy.hr/p/d049d083bd50-android-developer',
    },
    // {
    //   positionName: 'Angular Developer',
    //   className: 'box__image-detail--angular',
    //   image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Angular_Developer.jpg',
    //   imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Angular_Developer.webp',
    //   imageType: 'jpg',
    //   imageAlt: 'Angular-Typescript Developer',
    //   link: 'https://flowaccount.breezy.hr/p/44f95fa5d1a5-angular-typescript-developer',
    // },
    {
      positionName: 'Business Consultant',
      className: 'box__image-detail--accountant',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Business_Consultant.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Business_Consultant.webp',
      imageType: 'jpg',
      imageAlt: 'Junior Accountant / Business Consultant',
      link: 'https://flowaccount.breezy.hr/p/117d13886484-junior-accountant-business-consultant',
    },
    {
      positionName: 'C#.NET Developer',
      className: 'box__image-detail--c#',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/NET_Developer.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/NET_Developer.webp',
      imageType: 'jpg',
      imageAlt: 'C#.NET Developer',
      link: 'https://flowaccount.breezy.hr/p/f5613e41e7b2-c-net-developer',
    },
    {
      positionName: 'Content writer',
      className: 'box__image-detail--content-writer',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Content_writer.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Content_writer.webp',
      imageType: 'jpg',
      imageAlt: 'Content writer',
      link: 'https://flowaccount.breezy.hr/p/d9def7d00269-content-writer',
    },
    // {
    //   positionName: 'Customer Service Manager',
    //   className: 'box__image-detail--customer-service',
    //   image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Customer_Service_Manager.jpg',
    //   imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Customer_Service_Manager.webp',
    //   imageType: 'jpg',
    //   imageAlt: 'Customer Service Manager',
    //   link: 'https://flowaccount.breezy.hr/p/12f98cfccad9-customer-service-manager',
    // },
    {
      positionName: 'DevOps Engineer',
      className: 'box__image-detail--devop',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/DevOps_Engineer.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/DevOps_Engineer.webp',
      imageType: 'jpg',
      imageAlt: 'DevOps Engineer',
      link: 'https://flowaccount.breezy.hr/p/a3ac7d8d638e-devops-engineer',
    },
    {
      positionName: 'Front-end Developer',
      className: 'box__image-detail--frontend',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Front_end_Developer.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Front_end_Developer.webp',
      imageType: 'jpg',
      imageAlt: 'Front-end Developer',
      link: 'https://flowaccount.breezy.hr/p/e08888a6ea30-front-end-developer',
    },
    {
      positionName: 'iOS Developer',
      className: 'box__image-detail--ios',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/iOS_Developer.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/iOS_Developer.webp',
      imageType: 'jpg',
      imageAlt: 'iOS Developer',
      link: 'https://flowaccount.breezy.hr/p/506cb874791b-ios-developer',
    },
    {
      positionName: 'Junior Accountant ',
      className: 'box__image-detail--accountant',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Junior_Accountant.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Junior_Accountant.webp',
      imageType: 'jpg',
      imageAlt: 'Junior Accountant / Business Consultant',
      link: 'https://flowaccount.breezy.hr/p/117d13886484-junior-accountant-business-consultant',
    },
    // {
    //   positionName: 'Junior Talent Recruiter',
    //   className: 'box__image-detail--recruiter',
    //   image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Junior_Talent_Recruiter.jpg',
    //   imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Junior_Talent_Recruiter.webp',
    //   imageType: 'jpg',
    //   imageAlt: 'Junior Talent Recruiter',
    //   link: 'https://flowaccount.breezy.hr/p/0352769421ae-junior-talent-recruiter',
    // },

    {
      positionName: 'Product Owner',
      className: 'box__image-detail--product-owner',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Product_Owner.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Product_Owner.webp',
      imageType: 'jpg',
      imageAlt: 'Product Owner',
      link: 'https://flowaccount.breezy.hr/p/c2c062a1f4f4-product-owner',
    },
    {
      positionName: 'QA Automation',
      className: 'box__image-detail--qa',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/QA_Automation.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/QA_Automation.webp',
      imageType: 'jpg',
      imageAlt: 'QA Automation',
      link: 'https://flowaccount.breezy.hr/p/a2765e81b39c-qa-automation',
    },
    // {
    //   positionName: 'Sales Representative',
    //   className: 'box__image-detail--sale',
    //   image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Sales_Representative.jpg',
    //   imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Sales_Representative.webp',
    //   imageType: 'jpg',
    //   imageAlt: 'Sales Representative',
    //   link: 'https://flowaccount.breezy.hr/p/b09d158bd26d-sales-representative',
    // },
    {
      positionName: 'Web Designer',
      className: 'box__image-detail--web-designer',
      image: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Web_Designer.jpg',
      imageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section7/Web_Designer.webp',
      imageType: 'jpg',
      imageAlt: 'Web Designer',
      link: 'https://flowaccount.breezy.hr/p/84a29466a10e-web-designer',
    },
  ]

  constructor(public translate: TranslateService) {}


  counter(index: number) {
    return new Array(index)
  }
}
